import React, { Component } from 'react';
import { Card, CardMedia, CardText } from 'material-ui/Card';
import moment from 'moment';
import InstagramEmbed from 'react-instagram-embed';
import defaultPoster from "../imgs/default_poster.png";

const cardCustomStyle = {
    cardWrapperStyle: {
        fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"',
    },
    cardMediaStyle: {
        height: '130px',
        overflow: 'hidden',
    },
    cardTextStyle: {
        textAlign: 'left',
        height: '110px',
        margin: '40px 10px 20px',
        padding: '0',
        overflow: 'hidden',
        lineHeight: '27px',
    }
}

class Card_Custom extends Component {

    createMarkup(pd) {
        return { __html: `<div style="position:absolute; height:100%; width:100%; z-index:2;"></div><iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3D${pd[1]}%26id%3D${pd[0]}&show_text=false&lazy=true&width=350" width="350"  style="border:none;position: relative;top: 0;height:100%; z-index:1;" scrolling="no" frameBorder="0" allowFullScreen="true" ></iframe>` };
    }

    createIgMarkup(pd) {
        let igHash = pd.split("/").pop()
        return { __html: `<iframe class="instagram-media instagram-media-rendered" src="https://www.instagram.com/p/${igHash}/embed/captioned" allowtransparency="true" allowfullscreen="true" frameborder="0" height="706" data-instgrm-payload-id="instagram-media-payload-3" scrolling="no" style="background: white; max-width: 320px; width: calc(100% - 2px); border-radius: 3px; border: 1px solid rgb(219, 219, 219); box-shadow: none; display: block; margin: 0px 0px 12px; min-width: 326px; padding: 0px;"></iframe>` }
    }

    renderImage = (card, showSourceIcon) => {
        if (card.posterimg) {
            if (card.source === 'IG') {
                // return(
                //     <div className="igEmbedWrap">
                //         {this.checkSourceIcon(showSourceIcon,card.source)}
                //         <InstagramEmbed
                //             url={card.contentpath}
                //             clientAccessToken='344645639216936|5666a21315d3e449bb45f09834963fd8'
                //             maxWidth={320}
                //             hideCaption={false}
                //             containerTagName='div'
                //             protocol=''
                //             injectScript
                //             onLoading={() => {}}
                //             onSuccess={() => {}}
                //             onAfterRender={() => {}}
                //             onFailure={() => {}}
                //         />
                //     </div>
                // )
                return (
                    <div className="igEmbedWrap">
                        {this.checkSourceIcon(showSourceIcon, card.source)}
                        <div dangerouslySetInnerHTML={this.createIgMarkup(card.contentpath)} />
                    </div>
                )
            } else if (card.source === 'FB') {
                return (
                    <div style={{ position: 'relative' }}>
                        {this.checkSourceIcon(showSourceIcon, card.source)}
                        <div style={{ position: 'relative', overflow: 'hidden', maxHeight: '130px', display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }} dangerouslySetInnerHTML={this.createMarkup(card.contentpath.replace('https://www.facebook.com/', '').split('_'))} />
                    </div>
                )
            } else {
                return (
                    <CardMedia style={cardCustomStyle.cardMediaStyle}>
                        <div className="cardimg" style={{ backgroundImage: `url(${card.posterimg}), url(${defaultPoster})` }}>
                            {this.checkSourceIcon(showSourceIcon, card.source)}
                        </div>
                    </CardMedia>
                )
            }

        } else {
            return (
                <CardMedia style={cardCustomStyle.cardMediaStyle}>
                    <div className="cardimg default" style={{ backgroundImage: `url(${defaultPoster})` }}>
                        {this.checkSourceIcon(showSourceIcon, card.source)}
                    </div>
                </CardMedia>
            )
        }
    }

    renderDefalutPoster = (card, showSourceIcon) => {
        return (
            <CardMedia style={cardCustomStyle.cardMediaStyle}>
                <div className="cardimg default" style={{ backgroundImage: `url(${defaultPoster})` }}>
                    {this.checkSourceIcon(showSourceIcon, card.source)}
                </div>
            </CardMedia>
        )
    }

    renderText = (card) => {
        if (card.text) {
            return (
                <CardText style={cardCustomStyle.cardTextStyle}>
                    {card.text}
                </CardText>
            )
        } else {
            return (
                <CardText style={cardCustomStyle.cardTextStyle}>
                </CardText>
            )
        }
    }

    renderShareIcon = (card) => {
        if (card.source === 'FB') {
            return (
                <span className="iconWrap">
                    <span className="k_sprite1 sprite-icon-reply"></span>
                    <span className="posttypeValue">{card['share']}</span>
                </span>
            )
        }
    }

    checkSourceIcon = (showSourceIcon, source) => {
        if (showSourceIcon) {
            return (
                <span className={`profileTab sourceIcon ${source}_tag`}></span>
            )
        }
    }

    renderEmptyResult = () => {
        return (
            <div className="emptyResult">
                <div className="messageBox">
                    <span className="k_sprite1 sprite-icon-notfound"></span>
                    <p className="message">噢哦~沒有符合關鍵字的貼文</p>
                </div>
            </div>
        )
    }

    render() {
        const { cardinfo, showSourceIcon } = this.props
        let cardCustom = []

        if (cardinfo.length) {
            cardCustom = cardinfo.map((card, idx) => {
                const postdate = moment(card.date).subtract(8, 'hours').format('YYYY-MM-DD').toString()

                return (
                    <a href={card.contentpath} className="infoBox" target="_blank" key={idx}>
                        <Card className="cardWrapper" style={cardCustomStyle.cardWrapperStyle}>
                            {this.renderImage(card, showSourceIcon)}
                            <div className="textWrapper">
                                <span className="date">{postdate}</span>
                                {this.renderText(card)}
                            </div>
                            <CardText className="card_reactions">
                                <span className="iconWrap">
                                    <span className="k_sprite1 sprite-icon-thumb"></span>
                                    <span className="posttypeValue">{card['likes']}</span>
                                </span>
                                {this.renderShareIcon(card)}
                                <span className="iconWrap">
                                    <span className="k_sprite1 sprite-icon-message"></span>
                                    <span className="posttypeValue">{card['comment']}</span>
                                </span>
                            </CardText>
                        </Card>
                    </a>
                )
            })
        } else {
            cardCustom = this.renderEmptyResult()
        }

        return (
            <div className="infoBoxWrapper">{cardCustom}</div>
        )

    }
}

export default Card_Custom;


// WEBPACK FOOTER //
// ./src/components/card.js